module.exports = __webpack_public_path__ + "img/users.7e87550.svg";